export enum CONVERSION_TRACKING_MODE {
  S2S = 's2s',
  THIRD_PARTY_COOKIE = 'tpc',
  FIRST_PARTY_COOKIE = 'fpc',
}
